"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _templateStore = require("../utils/templateStore");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'ReceiptPreview',
  props: {
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    data: {
      type: Object,
      default: function _default() {
        return {
          goods: []
        };
      }
    },
    compact: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    maskedPhone: function maskedPhone() {
      return (0, _templateStore.maskPhone)(this.data.phone);
    },
    maskedAddress: function maskedAddress() {
      return (0, _templateStore.maskAddress)(this.data.address);
    },
    totalPrice: function totalPrice() {
      return (this.data.goods || []).reduce(function (sum, item) {
        return sum + Number(item.price || 0);
      }, 0);
    }
  },
  methods: {
    formatPrice: function formatPrice(v) {
      return Number(v || 0).toFixed(2);
    },
    getBarcode: function getBarcode(item, idx) {
      return String(item.name.length * 1000 + item.quantity * 100 + idx).padStart(8, '0');
    }
  }
};